var ccManager = {
    changedCCids: [],
    changedCartarticleIds: [],
    cartarticleChanged: function (cartarticleId) {
        if (this.changedCartarticleIds.indexOf(cartarticleId) == -1) {
            this.changedCartarticleIds.push(cartarticleId);
        }

        // Insert into the hidden field:
        $("#this.changedCartarticleIds").val(this.changedCartarticleIds.join(';'));
    },
    rowChanged: function (ccId) {
        if (this.changedCCids.indexOf(ccId) == -1) {
            this.changedCCids.push(ccId);
        }

        $("#errormessage_from_error_class2").html('');
    },
    saveChanges: function (messageOneSaved, messageMultipleSaved, messageError) {
        var $form = $("#ccmanagerform"),
            url = window.location;

        var dataToUpdate = {};

        dataToUpdate["updccid"] = this.changedCCids;

        // If there are changed elements, let's find the data and save it:
        if (this.changedCCids.length > 0) {
            for (var i = 0; i < this.changedCCids.length; i++) {
                dataToUpdate["updccccname" + this.changedCCids[i].toString()] = $('[name="updccccname' + this.changedCCids[i].toString() + '"]').val();
                dataToUpdate["updccccid" + this.changedCCids[i].toString()] = $('[name="updccccid' + this.changedCCids[i].toString() + '"]').val();
                dataToUpdate["updcclimit" + this.changedCCids[i].toString()] = $('[name="updcclimit' + this.changedCCids[i].toString() + '"]').val();
                dataToUpdate["updccaddsupervisorlimit" + this.changedCCids[i].toString()] = $('[name="updccaddsupervisorlimit' + this.changedCCids[i].toString() + '"]').val();
                dataToUpdate["updccaddsupervisorlimit2" + this.changedCCids[i].toString()] = $('[name="updccaddsupervisorlimit2' + this.changedCCids[i].toString() + '"]').val();
                dataToUpdate["updccaddsupervisorlimit3" + this.changedCCids[i].toString()] = $('[name="updccaddsupervisorlimit3' + this.changedCCids[i].toString() + '"]').val();
                dataToUpdate["updccaddsupervisorlimit4" + this.changedCCids[i].toString()] = $('[name="updccaddsupervisorlimit4' + this.changedCCids[i].toString() + '"]').val();
                dataToUpdate["updccaddsupervisorlimit5" + this.changedCCids[i].toString()] = $('[name="updccaddsupervisorlimit5' + this.changedCCids[i].toString() + '"]').val();
                dataToUpdate["cclocationlist" + this.changedCCids[i].toString()] = $('[name="cclocationlist' + this.changedCCids[i].toString() + '"]').val();
                dataToUpdate["updcccurrency_" + this.changedCCids[i].toString()] = $('[name="updcccurrency_' + this.changedCCids[i].toString() + '"]').val();
            }

            $("#ccmanagerform :input").each(function (index, elm) {
                var $elm = $(elm);
                if ($(this).attr("type") == 'hidden' && $(this).attr("name") != 'updccid[]') {
                    dataToUpdate[$(this).attr("name")] = $(this).val();
                }
            });

            $.post(url, dataToUpdate, function (data) {
                    var isFailed = data.match(/##costcenterLocationChangeFailed##/);
                    data = null;

                    if (!isFailed) {
                        if (this.changedCCids.length > 1) {
                            $("#errormessage_from_error_class2").html(drawMessageTable(this.changedCCids.length.toString() + " " + messageMultipleSaved, 'green'));
                        } else if (this.changedCCids.length === 1) {
                            $("#errormessage_from_error_class2").html(drawMessageTable(messageOneSaved, 'green'));
                        }
                    } else {
                        $("#errormessage_from_error_class2").html(drawMessageTable(messageError, 'red'));
                    }


                    this.changedCCids = new Array();
                }
            );
        }
    },
    drawMessageTable: function (message, color) {
        var table = '<table align="center" cellpadding="5" cellspacing="0"><tbody><tr><td>';
        table += '<table style="border: 2px solid ' + color + ';" align="center" cellpadding="5" cellspacing="0" width="100%"><tbody><tr><td align="left" valign="top"><font color="' + color + '">';
        table += message;
        table += '<br /></font></td></tr></tbody></table></td></tr></tbody></table>';

        return table;
    }
}


